const reservedFirstSegments = new Set([
  "admin",
  "api",
  "cardapio-digital-publico",
  "cardapio-pronto-gratis",
  "quiz",
  "como-funciona",
  "courier",
  "g",
  "home",
  "kitchen",
  "bar",
  "login",
  "privacy-policy",
  "refund-policy",
  "cancellation-policy",
  "reset-password",
  "restaurantes",
  "sign-up",
  "sign-up-first-step",
  "sign-up-second-step",
  "solucoes",
  "terms-of-service",
  "tutoriais",
])

export const isRestaurantPublicTrackingPath = (pathname: string) => {
  const segments = pathname.split("/").filter(Boolean)

  if (segments.length === 0) {
    return false
  }

  const [firstSegment] = segments

  return /^[a-z0-9-]+$/.test(firstSegment) && !reservedFirstSegments.has(firstSegment)
}
